interface ResizeHandlesProps {
    cardId: string;
    onResizeMouseDown: (e: React.MouseEvent, id: string, edge: string) => void;
}

const ResizeHandles = ({ cardId, onResizeMouseDown }: ResizeHandlesProps) => {
    return (
        <>
            {/* Corner Handles */}
            <div
                className="resize-handle"
                onMouseDown={(e) => onResizeMouseDown(e, cardId, 'nw')}
                style={{
                    position: 'absolute',
                    top: 0,
                    left: 0,
                    width: '12px',
                    height: '12px',
                    cursor: 'nw-resize',
                    zIndex: 10
                }}
            />
            <div
                className="resize-handle"
                onMouseDown={(e) => onResizeMouseDown(e, cardId, 'ne')}
                style={{
                    position: 'absolute',
                    top: 0,
                    right: 0,
                    width: '12px',
                    height: '12px',
                    cursor: 'ne-resize',
                    zIndex: 10
                }}
            />
            <div
                className="resize-handle"
                onMouseDown={(e) => onResizeMouseDown(e, cardId, 'sw')}
                style={{
                    position: 'absolute',
                    bottom: 0,
                    left: 0,
                    width: '12px',
                    height: '12px',
                    cursor: 'sw-resize',
                    zIndex: 10
                }}
            />
            <div
                className="resize-handle"
                onMouseDown={(e) => onResizeMouseDown(e, cardId, 'se')}
                style={{
                    position: 'absolute',
                    bottom: 0,
                    right: 0,
                    width: '12px',
                    height: '12px',
                    cursor: 'se-resize',
                    zIndex: 10
                }}
            />

            {/* Edge Handles */}
            <div
                className="resize-handle"
                onMouseDown={(e) => onResizeMouseDown(e, cardId, 'n')}
                style={{
                    position: 'absolute',
                    top: 0,
                    left: '12px',
                    right: '12px',
                    height: '4px',
                    cursor: 'n-resize',
                    zIndex: 10
                }}
            />
            <div
                className="resize-handle"
                onMouseDown={(e) => onResizeMouseDown(e, cardId, 's')}
                style={{
                    position: 'absolute',
                    bottom: 0,
                    left: '12px',
                    right: '12px',
                    height: '4px',
                    cursor: 's-resize',
                    zIndex: 10
                }}
            />
            <div
                className="resize-handle"
                onMouseDown={(e) => onResizeMouseDown(e, cardId, 'w')}
                style={{
                    position: 'absolute',
                    top: '12px',
                    bottom: '12px',
                    left: 0,
                    width: '4px',
                    cursor: 'w-resize',
                    zIndex: 10
                }}
            />
            <div
                className="resize-handle"
                onMouseDown={(e) => onResizeMouseDown(e, cardId, 'e')}
                style={{
                    position: 'absolute',
                    top: '12px',
                    bottom: '12px',
                    right: 0,
                    width: '4px',
                    cursor: 'e-resize',
                    zIndex: 10
                }}
            />
        </>
    );
};

export default ResizeHandles;
